import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { IThemeForm } from './themes.interface';
import { ThemeService } from '../../services/theme.service';
import { Subject, switchMap } from 'rxjs';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-themes',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ThemesComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();
  private readonly dialogRef = inject<MatDialogRef<ThemesComponent>>(MatDialogRef);

  public themeForm!: FormGroup<IThemeForm>;
  public readonly themeService = inject(ThemeService);
  public readonly baseService = inject(BaseService);

  ngOnInit(): void {
    this.themeService.getThemesPreviews();
    this.initForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  initForm(): void {
    this.themeForm = new FormGroup({
      theme: new FormControl(this.themeService.theme?.name || null),
    });
  }

  select(): void {
    const theme = this.themeForm.controls.theme.value;
    if (!theme) return;

    this.themeService.preview(theme);
  }

  save(): void {
    const theme = this.themeForm.controls.theme.value;
    if (!theme) return;

    this.themeService
      .setTheme(theme)
      .pipe(switchMap(() => this.baseService.getProfile()))
      .subscribe({
        next: () => {
          this.themeService.getTheme();
          this.themeService.reset();
          this.dialogRef.close(true);
        },
      });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
